import { render, staticRenderFns } from "./OccupancyPaxTheme2.vue?vue&type=template&id=ace28784&scoped=true"
import script from "./OccupancyPaxTheme2.vue?vue&type=script&lang=js"
export * from "./OccupancyPaxTheme2.vue?vue&type=script&lang=js"
import style0 from "./OccupancyPaxTheme2.vue?vue&type=style&index=0&id=ace28784&prod&lang=scss&scoped=true"
import style1 from "./OccupancyPaxTheme2.vue?vue&type=style&index=1&id=ace28784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace28784",
  null
  
)

export default component.exports